/**
 * 接口地址的统一管理
 */
const base = {
  url: process.env.VUE_APP_BASE_API
}
export default {
  utils: {
    uploadFile: `${base.url}/proxy_cfint/util/uploadTemplate`
  },
  //账户概况
  accountAnalyseVn: {
    getData: `${base.url}/proxy_cfint/accountAnalyseVn/getData`,
    getAccountSurvey: `${base.url}/proxy_cfint/accountAnalyseVn/getAccountSurvey`,
    getDataActivate: `${base.url}/proxy_cfint/accountAnalyseVn/getDataActivate`,
    accountExport: `${base.url}/proxy_cfint/accountAnalyseVn/accountExport`,
    activateExport: `${base.url}/proxy_cfint/accountAnalyseVn/activateExport`
  },
  //存款概况
  chshinAnalyseVn: {
    getData: `${base.url}/proxy_cfint/chshinAnalyseVn/getData`,
    getDeposit: `${base.url}/proxy_cfint/chshinAnalyseVn/getDeposit`,
    depositExport: `${base.url}/proxy_cfint/chshinAnalyseVn/depositExport`,
    getDepositMoney: `${base.url}/proxy_cfint/chshinAnalyseVn/getDepositMoney`,
    depositMoneyExport: `${base.url}/proxy_cfint/chshinAnalyseVn/depositMoneyExport`
  },
  //取款概况
  chshoutAnalyseVn: {
    getData: `${base.url}/proxy_cfint/chshoutAnalyseVn/getData`,
    withdrawal: `${base.url}/proxy_cfint/chshoutAnalyseVn/withdrawal`,
    withdrawalExport: `${base.url}/proxy_cfint/chshoutAnalyseVn/withdrawalExport`,
    getPoorData: `${base.url}/proxy_cfint/chshoutAnalyseVn/getPoorData`,
    poor: `${base.url}/proxy_cfint/chshoutAnalyseVn/poor`,
    poorExport: `${base.url}/proxy_cfint/chshoutAnalyseVn/poorExport`
  },
  //交易概况
  realVn: {
    getData: `${base.url}/proxy_cfint/dealAnalyseVn/getData`,
    deal: `${base.url}/proxy_cfint/dealAnalyseVn/deal`,
    dealExport: `${base.url}/proxy_cfint/dealAnalyseVn/dealExport`,
    dealHand: `${base.url}/proxy_cfint/dealAnalyseVn/dealHand`,
    dealHandExport: `${base.url}/proxy_cfint/dealAnalyseVn/dealHandExport`,
    dealProduction: `${base.url}/proxy_cfint/dealAnalyseVn/dealProduction`,
    dealProductionExport: `${base.url}/proxy_cfint/dealAnalyseVn/dealProductionExport`
  },
  //代理设置
  adAgent: {
    rebateSetList: `${base.url}/proxy_cfint/adAgent/rebateSet/list`,
    rebateSetDel: `${base.url}/proxy_cfint/adAgent/rebateSet/del`,
    rebateSetEdit: `${base.url}/proxy_cfint/adAgent/rebateSet/edit`,
    rebateSetDetail: `${base.url}/proxy_cfint/adAgent/rebateSet/detail`,
    rebateSetStatus: `${base.url}/proxy_cfint/adAgent/rebateSet/status`,
    rebateSetListAll: `${base.url}/proxy_cfint/adAgent/rebateSet/listAll`,
    symbolList: `${base.url}/proxy_cfint/adAgent/symbol/list`,
    symbolEdit: `${base.url}/proxy_cfint/adAgent/symbolConf/edit`,
    symbolHistory: `${base.url}/proxy_cfint/adAgent/symbolConf/history`,
    personnelList: `${base.url}/proxy_cfint/adAgent/personnel/list`,
    personnelDel: `${base.url}/proxy_cfint/adAgent/personnel/del`,
    personnelEdit: `${base.url}/proxy_cfint/adAgent/personnel/edit`,
    personnelStatus: `${base.url}/proxy_cfint/adAgent/personnel/status`,
    personnelCascader: `${base.url}/proxy_cfint/adAgent/personnel/cascader`,
    customerList: `${base.url}/proxy_cfint/adAgent/customer/list`,
    customerStatistics: `${base.url}/proxy_cfint/adAgent/customer/statistics`,
    customerUpdateInfo: `${base.url}/proxy_cfint/adAgent/customer/updateInfo`,
    customerDown: `${base.url}/proxy_cfint/adAgent/customer/down`,
    customerApplyImport: `${base.url}/proxy_cfint/adAgent/customerApply/import`,
    customerApplyList: `${base.url}/proxy_cfint/adAgent/customerApply/list`,
    customerApplyStatus: `${base.url}/proxy_cfint/adAgent//customerApply/status`,
    customerApplyDel: `${base.url}/proxy_cfint/adAgent//customerApply/del`,
    levelList: `${base.url}/proxy_cfint/adAgent/level/list`,
    rebateLevel: `${base.url}/proxy_cfint/adAgent/rebate/levels`,
    rebateDetailList: `${base.url}/proxy_cfint/adAgent/rebatedetail/list`,
    rebateDetailTotal: `${base.url}/proxy_cfint/adAgent/rebatedetail/total`,
    rebateDetailDown: `${base.url}/proxy_cfint/adAgent/rebatedetail/down`,
    personnelApplyList: `${base.url}/proxy_cfint/adAgent/personnelApply/list`,
    personnelApplyStatus: `${base.url}/proxy_cfint/adAgent/personnelApply/status`,
    personnelApplyDel: `${base.url}/proxy_cfint/adAgent/personnelApply/del`,
    rebateMonthProvide: `${base.url}/proxy_cfint/adAgent/rebateMonth/provide`,
    rebateMonthList: `${base.url}/proxy_cfint/adAgent/rebateMonth/list`,
    excludeCustomers:`${base.url}/proxy_cfint/adAgent/exclude/list`,
    delExcludeCustomers:`${base.url}/proxy_cfint/adAgent/exclude/del`,
    saveExcludeCustomers:`${base.url}/proxy_cfint/adAgent/exclude/add`,
    creditLinePno:{
      list:`${base.url}/proxy_cfint/adAgent/creditPno/list`,
      edit:`${base.url}/proxy_cfint/adAgent/creditPno/edit`,
      reject:`${base.url}/proxy_cfint/adAgent/creditPno/reject`,
      apply:`${base.url}/proxy_cfint/adAgent/creditPno/apply`,
    },
    creditRecord:{
      list:`${base.url}/proxy_cfint/adAgent/creditRecord/list`,
    },
    customerCreditRecord:{
      list:`${base.url}/proxy_cfint/adAgent/customerCreditRecord/list`,
    },
    creditInfo:{
      list:`${base.url}/proxy_cfint/adAgent/creditInfo/list`,
      freeze:`${base.url}/proxy_cfint/adAgent/creditInfo/freeze`,
      unfreeze:`${base.url}/proxy_cfint/adAgent/creditInfo/unfreeze`,
    },
    settingPersonnels: `${base.url}/proxy_cfint/adAgent/setting/personnels`,
    settingEdit: `${base.url}/proxy_cfint/adAgent/setting/edit`,
    settingStatus: `${base.url}/proxy_cfint/adAgent/setting/status`,
  }
}
